import React, { useEffect } from 'react';
import queryString from 'query-string';
import { useLocation } from 'react-router-dom';
import { connect } from 'react-redux';

import CreatePasswordModal from 'Components/CreatePasswordModal';
import { useConfig } from 'Context/ConfigContext';
import { useClassroomInterruption } from 'Util/Hooks';

import { myProfile } from '../../../Redux/user-profile/selectors';

const CourseCreatePasswordModal = ({ myProfile }) => {
  const { enableCreatePasswordModal, resetPasswordUrl } = useConfig();
  const location = useLocation();
  const { isInterrupting, activateInterruption } = useClassroomInterruption();
  /*
    Quick register user enter classroom from welcome email
    with `token` that use to reset password
  */
  const { token } = queryString.parse(location?.search);
  const shouldUserCreatePassword =
    enableCreatePasswordModal && !myProfile?.isPassportUser && !myProfile?.isPasswordCreatedByUser;

  const handleCreatePasswordButtonClick = () => {
    const resetPasswordURL = new URL(resetPasswordUrl);
    if (token) {
      resetPasswordURL.searchParams.append('token', token);
    }
    window.location = resetPasswordURL.toString();
  };

  useEffect(() => {
    if (shouldUserCreatePassword) {
      activateInterruption();
    }
  }, []);

  if (!shouldUserCreatePassword) {
    return null;
  }

  return (
    <CreatePasswordModal
      isActive={isInterrupting}
      onCreatePasswordButtonClick={handleCreatePasswordButtonClick}
    />
  );
};

const mapStateToProps = (state) => ({
  myProfile: myProfile(state),
});

export default connect(mapStateToProps, {})(CourseCreatePasswordModal);
